module.exports = __webpack_public_path__ + "static/media/FiraSans-BoldItalic.2a3831c8.ttf";